import type { ArmSpec } from '../armRegistry';

export const fullAbstracts: ArmSpec = {
  stamp: (ctx) => ({
    render_state: ctx.cards().some((card) => card.hasHiddenAbstract)
      ? 'rendered'
      : 'fallback',
  }),

  onCards: (cards) => {
    cards.forEach((card) => card.expandAbstract());
  },
};
